export default __webpack_public_path__ + "static/9491f2e41c520aecc27f63c4ea7a9472.jpg";